import React, {useRef, useEffect} from 'react'
import {Button} from 'antd'
import SparkMD5 from 'spark-md5'

import {FileInfo} from '../../api/file_info'

interface Props {
  keyPrefix: string
  initFile: FileInfo
  setFile: (file: FileInfo) => void
  // url: string
}
const InputFile: React.FC<Props> = ({keyPrefix, initFile, setFile}) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  // const [file, setFile] = useState('')

  useEffect(() => {
    // let f = initFile
    // u = ObsKeyToURL(u)
    // setPreviewURL(u)
  }, [])

  const triggerInput = () => {
    inputRef.current?.click()
  }

  const onFileChange = e => {
    if (e.target.files.length <= 0) {
      return
    }

    let file: File = e.target.files[0]
    // 临时显示
    // setPreviewURL(getPreURL(file))

    // 计算md5并上传华为云
    fileMd5(file)
  }

  // 获取预览URL blob
  // const getPreURL = (file: File) => {
  //   let windowURL = window.URL || window.webkitURL
  //   let src = windowURL.createObjectURL(file)
  //   return src
  // }

  // 计算md5
  const fileMd5 = (file: File) => {
    let chunkSize = 2097152 // read in chunks of 2MB
    let fileIndex = 0
    let spark = new SparkMD5.ArrayBuffer()
    let fileReader = new FileReader()

    fileReader.onload = function (e) {
      let result = e.target?.result
      if (result && typeof result !== 'string') {
        spark.append(result)
      }
      if (fileIndex < file.size) {
        fileIndex = fileIndex + chunkSize
        loadNext()
      } else {
        let key = spark.end()
        if (urlChanged(key)) {
          if (!keyPrefix.endsWith('/')) {
            key = keyPrefix + '/' + key
          } else {
            key = keyPrefix + key
          }

          upload(key, file)
        }
      }
    }

    const loadNext = () => {
      const slice = file.slice(fileIndex, fileIndex + chunkSize)
      fileReader.readAsArrayBuffer(slice)
    }

    // 启动读取文件
    loadNext()
  }

  const urlChanged = (key: string): Boolean => {
    let arr = initFile.url.split('/')
    let oldKey = ''
    if (arr.length > 0) {
      oldKey = arr[-1]
    }

    return oldKey !== key
  }

  const getObsClient = () => {
    let ak = process.env.REACT_APP_HW_AK
    let sk = process.env.REACT_APP_HW_SK
    let server = process.env.REACT_APP_HW_SERVER

    return new ObsClient({
      access_key_id: ak,
      secret_access_key: sk,
      server: server,
      timeout: 60 * 5,
    })
  }

  const upload = (key: string, file: File) => {
    let bucket = process.env.REACT_APP_HW_BUCKET

    getObsClient()
      .putObject({
        Bucket: bucket,
        Key: key,
        SourceFile: file,
      })
      .then(res => {
        let index = file.name.lastIndexOf('.')
        setFile({
          name: file.name.substring(0, index),
          url: key,
          suffix: file.name.substring(index + 1),
        })
      })
  }

  return (
    <>
      <Button
        type="dashed"
        style={{width: 248, height: 64, padding: '12px'}}
        onClick={triggerInput}
      >
        <div
          style={{
            width: '100%',
            wordBreak: 'break-all',
            whiteSpace: 'normal',
            textAlign: 'center',
            marginBottom: 0,
          }}
        >
          {initFile.url === '' ? '添加文件' : initFile.name + '.' + initFile.suffix}
        </div>
      </Button>
      <input
        ref={inputRef}
        type="file"
        className="hide"
        accept="video/mp4,application/pdf, application/vnd.ms-powerpoint, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation, *"
        onChange={onFileChange}
      />
    </>
  )
}

export default InputFile
